import { useTranslation } from 'react-i18next';
import { Box, Typography, StackView } from '@telus-uds/components-web';

import { useTheme } from '../../BrandThemeProvider';

import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const { currentBrand } = useTheme();

  return (
    <Box variant={{ background: 'lighter' }}>
      <StackView
        tokens={{
          alignItems: 'center',
          justifyContent: 'center',
          flexGrow: 1,
        }}
      >
        <div className="footerContentContainer">
          <Box vertical={6} horizontal={2} flex={1}>
            <StackView
              direction="row"
              tokens={{
                alignItems: 'center',
                justifyContent: 'space-between',
                flexGrow: 1,
              }}
            >
              <img src={`/logos/${currentBrand}.svg`} alt="Brand Logo" className="brand-logo-small" />
              <Typography tag="p" variant={{ colour: 'light' }}>
                {t('copyright', { brand: currentBrand, year: new Date().getFullYear() })}
              </Typography>
            </StackView>
          </Box>
        </div>
      </StackView>
    </Box>
  );
};

export default Footer;
